module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/feature02-4dfc06b2cf4492dac8b46ad12226d183.svg";